import HeaderFixedNav from './sections/HeaderFixedNav';
import BannerAnnouncementStrip from './sections/BannerAnnouncementStrip';
import HeroSplitEditorial from './sections/HeroSplitEditorial';
import HeroPortalCards from './sections/HeroPortalCards';
import ChallengesGrid from './sections/ChallengesGrid';
import BenefitsBentoGrid from './sections/BenefitsBentoGrid';
import BenefitsCardDeck from './sections/BenefitsCardDeck';
import InsightsParallelPanels from './sections/InsightsParallelPanels';
import HowItWorksTimeline from './sections/HowItWorksTimeline';
import KeyBenefitsCardGrid from './sections/KeyBenefitsCardGrid';
import StatisticsMetricsShowcase from './sections/StatisticsMetricsShowcase';
import StatisticsSimpleGrid from './sections/StatisticsSimpleGrid';
import ImplementationPhasesGrid from './sections/ImplementationPhasesGrid';
import CtaDualButton from './sections/CtaDualButton';
import FooterMultiZone from './sections/FooterMultiZone';
import PermitsCatalog from './sections/PermitsCatalog';

const layoutRegistry = {
    header: {
        default: HeaderFixedNav
    },
    banner: {
        default: BannerAnnouncementStrip
    },
    hero: {
        splitEditorial: HeroSplitEditorial,
        portalCards: HeroPortalCards,
        default: HeroSplitEditorial
    },
    challenges: {
        gridHighlight: ChallengesGrid,
        default: ChallengesGrid
    },
    benefits: {
        cardDeck: BenefitsCardDeck,
        bentoGrid: BenefitsBentoGrid,
        default: BenefitsCardDeck
    },
    insights: {
        parallelPanels: InsightsParallelPanels,
        default: InsightsParallelPanels
    },
    howitworks: {
        timelineSteps: HowItWorksTimeline,
        default: HowItWorksTimeline
    },
    keybenefits: {
        cardGrid: KeyBenefitsCardGrid,
        default: KeyBenefitsCardGrid
    },
    statistics: {
        simpleGrid: StatisticsSimpleGrid,
        metricsShowcase: StatisticsMetricsShowcase,
        default: StatisticsMetricsShowcase
    },
    implementation: {
        phasesGrid: ImplementationPhasesGrid,
        default: ImplementationPhasesGrid
    },
    cta: {
        dualButton: CtaDualButton,
        default: CtaDualButton
    },
    footer: {
        multizone: FooterMultiZone,
        default: FooterMultiZone
    },
    permits: {
        catalog: PermitsCatalog,
        default: PermitsCatalog
    }
};

export default layoutRegistry;
